import type { PlantConfig } from '../../engine/plant/types';
import { equipment, extraTags, streams } from './equipment';
import { instruments } from './instruments';
import { alarms, interlocks, loops } from './control';
import { faults, kpis } from './faults';
import { layout } from './layout';
import { scenarios, tuningChallenges } from './scenarios';
import { designPreset } from './preset';
import { lessons } from './lessons';

export const crudeUnit: PlantConfig = {
  id: 'crude-unit',
  name: 'Eastport Crude Unit',
  description:
    'A 75 000 barrel-per-day atmospheric crude distillation unit: charge pump, three-stage ' +
    'preheat train, fired heater on cascade temperature control, and a tower making naphtha, ' +
    'kerosene, diesel and residue.',
  species: ['light', 'nap', 'ker', 'dsl', 'res'],
  density: 820,
  designConditions: {
    charge: 500,
    preheatOutlet: 495,
    coilOutlet: 623,
    tubeSkin: 683,
    columnPressure: 1.8,
    topTemperature: 393,
    reflux: 200,
    naphtha: 60,
    kerosene: 90,
    diesel: 125,
    residue: 225,
    columnDp: 0.35,
  },
  equipment,
  streams,
  instruments,
  loops,
  alarms,
  interlocks,
  faults,
  kpis,
  layout,
  scenarios: [...scenarios, ...tuningChallenges],
  lessons,
  extraTags,
  designPreset,
  warmStartS: 10_800,
  trendGroups: [
    { id: 'heater', name: 'Heater', tags: ['TT-201.PV', 'TIC-201.SP', 'TT-202.PV', 'FT-202.PV', 'AT-202.PV', 'FT-101.PV'] },
    { id: 'column', name: 'Column', tags: ['PT-301.PV', 'PDT-301.PV', 'TT-304.PV', 'TT-305.PV', 'TT-306.PV', 'TT-307.PV'] },
    { id: 'overhead', name: 'Overhead', tags: ['LT-302.PV', 'FT-303.PV', 'FT-304.PV', 'C-301.QCOND', 'TT-308.PV'] },
    { id: 'products', name: 'Products', tags: ['FT-304.PV', 'FT-305.PV', 'FT-306.PV', 'FT-307.PV', 'LT-307.PV'] },
    { id: 'quality', name: 'Quality', tags: ['AT-304.PV', 'AT-306.PV', 'C-301.SEP', 'C-301.VLOAD', 'CALC-QUAL.OUT'] },
    { id: 'preheat', name: 'Preheat', tags: ['TT-102.PV', 'TT-101.PV', 'HX-101.DUTY', 'HX-102.DUTY', 'HX-103.DUTY'] },
  ],
};
